module.exports = __webpack_public_path__ + "static/media/Notice_2_608_to_7802.31d5638c.pdf";